export const parseNumericValue = (value: unknown): number => {
  if (value === null || value === undefined || value === "") return 0;
  const parsed = parseFloat(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const createNumericSortFunction =
  (field: string) =>
  (rowA: any, rowB: any) =>
    parseNumericValue(rowA[field]) - parseNumericValue(rowB[field]);

export const createStringSortFunction =
  (field: string) =>
  (rowA: any, rowB: any) =>
    String(rowA[field] ?? "")
      .toLowerCase()
      .localeCompare(String(rowB[field] ?? "").toLowerCase());
